import { Injectable } from '@angular/core';
import { Login } from './model/Login';

@Injectable()
export class StorageService {

    data: Login;

    constructor() { }

    setData(data: any) {
        this.data = data;
    }

    getData() {
        return this.data;
    }
}
